/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/execution/commit 层；
 * 2. 负责定义特征正式提交执行器的统一抽象；
 * 3. 该层用于隔离“创建新特征”和“编辑既有特征”的正式提交策略。
 */

import type { FeatureDefinition } from '../../definition/FeatureDefinition';
import type { FeatureEditSession } from '../../edit/FeatureEditSession';
import type { FeaturePrototype } from '../../prototype/FeaturePrototype';

/**
 * 特征正式提交执行器抽象基类。
 */
export abstract class FeatureCommitExecution<
    TDefinition extends FeatureDefinition = FeatureDefinition,
    TPrototype extends FeaturePrototype<TDefinition> = FeaturePrototype<TDefinition>,
> {
    /**
     * 提交新建特征。
     *
     * @param prototype 特征原型。
     * @returns 提交后的结果对象 ID；多实体特征可返回多个对象 ID。
     */
    public abstract commitCreate(prototype: TPrototype): Promise<string | string[]>;

    /**
     * 提交既有特征编辑。
     *
     * @param session 编辑会话。
     * @param prototype 更新后的特征原型。
     * @returns 是否提交成功。
     */
    public abstract commitEdit(session: FeatureEditSession<TDefinition, TPrototype>, prototype: TPrototype): Promise<boolean>;
}
